function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function() {
		document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function(event) {
		if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);

	elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(":focus-visible");
} catch {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener('keydown', (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener('mousedown', (event) => {
		mouseClick = true;
	});

	window.addEventListener('focus', () => {
		if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

		if (mouseClick) return;

		currentFocusedElement = document.activeElement;
		currentFocusedElement.classList.add('focused');

	}, true);
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	});
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	document.querySelectorAll('video').forEach((video) => video.pause());
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;

	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', {
			bubbles: true
		})

		this.querySelectorAll('button').forEach(
			(button) => button.addEventListener('click', this.onButtonClick.bind(this))
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = form => {
	const obj = {};
	const formData = new FormData(form);

	for (const key of formData.keys()) {
		const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

		if (regex.test(key)) {
			obj.properties = obj.properties || {};
			obj.properties[regex.exec(key)[2]] = formData.get(key);
		} else {
			obj[key] = formData.get(key);
		}
	}

	return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Accept': `application/${type}`
		}
	};
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
	return function() {
		return fn.apply(scope, arguments);
	}
};

Shopify.setSelectorByValue = function(selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function(target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function() {
		var value = this.countryEl.getAttribute('data-default');
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function() {
		var value = this.provinceEl.getAttribute('data-default');
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function(e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute('data-provinces');
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none';
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option');
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function(selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function(selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option');
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	}
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector('details');
		const summaryElements = this.querySelectorAll('summary');
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

		this.addEventListener('keyup', this.onKeyUp.bind(this));
		this.addEventListener('focusout', this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
		this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach(element => {
			element.setAttribute('role', 'button');
			element.setAttribute('aria-expanded', false);
			element.setAttribute('aria-controls', element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		const openDetailsElement = event.target.closest('details[open]');
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute('open');

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
		} else {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

			setTimeout(() => {
				detailsElement.classList.add('menu-opening');
			});
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening');
		});
		summaryElement.setAttribute('aria-expanded', true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening');
			this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
				details.removeAttribute('open');
				details.classList.remove('menu-opening');
			});
			this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details');
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening');
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute('open');
				if (detailsElement.closest('details[open]')) {
					trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
				}
			}
		}

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.getElementById('shopify-section-header');
		this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
		document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening');
		});

		summaryElement.setAttribute('aria-expanded', true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			'click',
			this.hide.bind(this)
		);
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide();
		});
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
			});
		} else {
			this.addEventListener('click', (event) => {
				if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
			});
		}
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector('.template-popup');
		document.body.classList.add('overflow-hidden');
		this.setAttribute('open', '');
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		document.body.classList.remove('overflow-hidden');
		this.removeAttribute('open');
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector('button');

		if (!button) return;
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'));
			if (modal) modal.show(button);
		});
	}
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener('click', this.loadContent.bind(this));
	}

	loadContent() {
		window.pauseAllMedia();
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

			this.setAttribute('loaded', true);
			this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
		}
	}
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector('ul');
		this.sliderItems = this.querySelectorAll('li');
		this.pageCount = this.querySelector('.slider-counter--current');
		this.pageTotal = this.querySelector('.slider-counter--total');
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		const resizeObserver = new ResizeObserver(entries => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener('scroll', this.update.bind(this));
		this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
		this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
	}

	initPages() {
		const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
		this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
		if (sliderItemsToShow.length === 0) return;
		this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
		this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
		this.update();
	}

	update() {
		if (!this.pageCount || !this.pageTotal) return;
		this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

		if (this.currentPage === 1) {
			this.prevButton.setAttribute('disabled', true);
		} else {
			this.prevButton.removeAttribute('disabled');
		}

		if (this.currentPage === this.totalPages) {
			this.nextButton.setAttribute('disabled', true);
		} else {
			this.nextButton.removeAttribute('disabled');
		}

		this.pageCount.textContent = this.currentPage;
		this.pageTotal.textContent = this.totalPages;
	}

	onButtonClick(event) {
		event.preventDefault();
		const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition
		});
	}
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, '', false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options.map((option, index) => {
				return this.options[index] === option;
			}).includes(false);
		});
	}

	updateMedia() {
		if (!this.currentVariant) return;
		if (!this.currentVariant.featured_media) return;
		const newMedia = document.querySelector(
			`[data-media-id="${this.currentVariant.featured_media.id}"]`
		);
		if (!newMedia) return;
		let slideno = newMedia.closest('[data-index-slide]').dataset.slickIndex;
		$('.product-featured-images-wrapper').slick('slickGoTo', slideno);

		const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
		const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
		const parent = newMedia.parentElement; 
		if (parent.firstChild == newMedia) return;
		modalContent.prepend(newMediaModal);
		parent.prepend(newMedia);
		this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
		if (this.stickyHeader) {
			this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
		}
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
		window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', {
				bubbles: true
			}));
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability');
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute('available');
			pickUpAvailability.innerHTML = '';
		}
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
			.then((response) => response.text())
			.then((responseText) => {
				const id = `price-${this.dataset.section}`;
				const html = new DOMParser().parseFromString(responseText, 'text/html')
				const destination = document.getElementById(id);
				const source = html.getElementById(id);
				const variantPickerDestination = document.querySelector('variant-radios') || document.querySelector('variant-selects');
				const variantPickerSource = html.querySelector('variant-radios') || html.querySelector('variant-selects');

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (variantPickerSource && variantPickerDestination) variantPickerDestination.innerHTML = variantPickerSource.innerHTML;

				const price = document.getElementById(`price-${this.dataset.section}`);
				if (price) price.classList.remove('visibility-hidden');

				const sku = document.getElementById(`sku-${this.dataset.section}`);
				if (sku) sku.classList.remove('visibility-hidden'), this.updateSku(html);

				// The discount sash sits over the product image, outside
				// #price-{section}, so the price swap above would leave it
				// showing the previous variant's saving. Swap it from the same
				// fetched document. innerHTML of the wrapper, not of the sash
				// itself: the sash is absent entirely when a variant is not
				// discounted, so there would be nothing to write into.
				const saleBadgeId = `sale-badge-${this.dataset.section}`;
				const saleBadgeDestination = document.getElementById(saleBadgeId);
				const saleBadgeSource = html.getElementById(saleBadgeId);
				if (saleBadgeSource && saleBadgeDestination) saleBadgeDestination.innerHTML = saleBadgeSource.innerHTML;



				this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
			});
	}

	updateSku(html) {
		const id = `sku-${this.dataset.section}`;
		const destination = document.getElementById(id);
		const source = html.getElementById(id);

		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');

		const addButtonText = productForm.querySelector('[name="add"] > span');

		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', true);

			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled', false);
			if (addButtonText != null) {
				addButtonText.textContent = window.variantStrings.addToCart;
			}
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);

		const sku = document.getElementById(`sku-${this.dataset.section}`);
		if (!addButton) return;
		if (sku) sku.classList.add('visibility-hidden');
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add('visibility-hidden');
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
		});
		var selected_option = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-inventory_quantity');
		});
        if (selected_option.length == 1) {
          jQuery(".quantity_text").html(selected_option[0] + " ");  
        } else {
          jQuery(".quantity_text").html(selected_option[1] + " ");
        }
      

	}
}

customElements.define('variant-radios', VariantRadios);